import React from 'react';

const CSVConversionModal = ({ show, setShow }) => {

    const handleClose = () => setShow(false);

    return (
        <>
            {show && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8 md:p-10 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-2xl w-full relative mx-4">
                        {/* Close Button */}
                        <button
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                            onClick={handleClose}
                        >
                            &times;
                        </button>

                        <h2 className="text-xl sm:text-2xl font-semibold mb-4">Comment convertir un fichier CSV en UTF-8</h2>
                        <h5 className="text-lg font-medium mb-3">Suivez les étapes suivantes selon votre système d'exploitation :</h5>

                        <h6 className="font-semibold">📄 Pour Windows :</h6>
                        <ol className="list-decimal list-inside ml-4 mb-4">
                            <li>Ouvrez votre fichier CSV dans Excel.</li>
                            <li>Allez dans <strong>Fichier</strong> &gt; <strong>Enregistrer sous</strong>.</li>
                            <li>Choisissez un emplacement et sélectionnez <strong>CSV UTF-8 (délimité par des virgules) (*.csv)</strong> comme type de fichier.</li>
                            <li>Enregistrez votre fichier.</li>
                        </ol>

                        <h6 className="font-semibold">📄 Pour macOS :</h6>
                        <ol className="list-decimal list-inside ml-4 mb-4">
                            <li>Ouvrez le fichier CSV dans l'application <strong>TextEdit</strong>.</li>
                            <li>Allez dans <strong>Format</strong> &gt; <strong>Convertir au format texte</strong> (si nécessaire).</li>
                            <li>Allez dans <strong>Fichier</strong> &gt; <strong>Enregistrer sous</strong>.</li>
                            <li>Dans la boîte de dialogue d'enregistrement, sélectionnez <strong>UTF-8</strong> dans la section <strong>Encodage</strong> et assurez-vous que l'extension est <strong>.csv</strong>.</li>
                            <li>Enregistrez le fichier.</li>
                        </ol>

                        <h6 className="font-semibold">📄 Pour Google Sheets :</h6>
                        <ol className="list-decimal list-inside ml-4 mb-4">
                            <li>Ouvrez votre fichier dans Google Sheets.</li>
                            <li>Allez dans <strong>Fichier</strong> &gt; <strong>Télécharger sous</strong> &gt; <strong>Valeurs séparées par des virgules (.csv)</strong>.</li>
                            <li>Le fichier téléchargé sera automatiquement encodé en UTF-8.</li>
                        </ol>

                        <button
                            onClick={handleClose}
                            className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 transition-colors mt-4"
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default CSVConversionModal;
